import React from 'react';
import { Typography } from '@mui/material';

import { Dialog } from '@paragon/popup-state';

interface Props {
  userVisibleAction: string;
  onClose(): void;
}

export function UnsavedChangesInfoDialog(props: Props) {
  return (
    <Dialog variant="design" title="Unsaved Changes" submitText="OK" onSubmit={props.onClose} onClose={props.onClose}>
      <Typography>
        You have unsaved changes. Please save or discard your changes before {props.userVisibleAction}.
      </Typography>
    </Dialog>
  );
}
